<div *ngIf="!loadedProfile" class="row">
  <nb-actions size="small" class="see-more-button">
    <nb-action (click)="getProfile()">
      <nb-icon class="action-icon" icon="more-horizontal-outline"></nb-icon>
      <span class="text-link">Xem thêm thông tin </span>
    </nb-action>
  </nb-actions>
</div>

<div
  *ngIf="loadedProfile"
  class="row"
  [nbSpinner]="loading"
  nbSpinnerStatus="info"
>
  <div class="col-12 col-sm-6 col-md-6">
    <nb-card>
      <nb-card-body>
        <ngx-view-image [imageURL]="imageURL" [size]="'small'"></ngx-view-image>
      </nb-card-body>

      <nb-card-footer>
        <h6 class="text-primary">
          {{ userData ? userData.displayName : "Anonymous" }}
        </h6>
      </nb-card-footer>
    </nb-card>
  </div>

  <div class="col-12 col-sm-6 col-md-6">
    <nb-card>
      <nb-menu [items]="profileItems"> </nb-menu>
    </nb-card>
  </div>
</div>

<nb-actions
  *ngIf="!moreInfo && loadedProfile"
  size="small"
  class="see-more-button"
>
  <nb-action (click)="getTutorCourses()">
    <nb-icon class="action-icon" icon="more-horizontal-outline"></nb-icon>
    <span class="text-link">Xem các khóa được chia sẻ </span>
  </nb-action>
</nb-actions>

<div *ngIf="loadedProfile" class="row">
  <div class="col-md-12 col-lg-12">
    <nb-card
      *ngIf="tutorCourses.length > 0"
      [nbSpinner]="loadingTutor"
      nbSpinnerStatus="info"
      nbSpinnerSize="giant"
    >
      <nb-card-header> Các khóa đang hướng dẫn </nb-card-header>
      <nb-card-body>
        <div class="row">
          <div
            *ngFor="let course of tutorCourses; let i = index"
            class="col-xxxl-4 col-xxl-4 col-lg-6 col-md-6"
          >
            <ngx-view-course
              [course]="course"
              [mode]="'course'"
              (onRedirect)="close($event)"
            ></ngx-view-course>
          </div>
        </div>

        <div *ngIf="!done" class="row">
          <nb-actions size="small" class="see-more-button">
            <nb-action (click)="getTutorCourses()">
              <nb-icon
                class="action-icon"
                icon="more-horizontal-outline"
              ></nb-icon>
              <span class="text-link">Xem thêm </span>
            </nb-action>
          </nb-actions>
        </div>
      </nb-card-body>
    </nb-card>
  </div>
</div>
